export const HASH_VERSIONS = {
    1: { memorySize: 65536, iterations: 3, parallelism: 1, hashLength: 32 },
};
export const CURRENT_HASH_VERSION = 1;
export const SUPPORTED_HASH_VERSIONS = [1];
//# sourceMappingURL=hash-version.js.map